export enum UserRoleType {
  Carrier = 'CARRIER',
  Common = 'COMMON',
  Customer = 'CUSTOMER',
  DockYard = 'DOCK_YARD',
  GoodsReceipt = 'GOODS_RECEIPT',
  Supplier = 'SUPPLIER',
  TrackTrace = 'TRACK_TRACE',
}
